import type { FC, ReactElement, ReactNode } from 'react';
import { StrictMode } from 'react';

import { QueryClientProvider, getSseEventBus } from '@luna/api';
import { HashRouter } from '@luna/router';
import { RootErrorBoundary } from '@shared/error-boundary';
import { isFeatureEnabled } from '@luna/gatekeeper';
import { useDarkMode } from '@shared/dark-mode';

import { GDSProvider } from './GDSProvider';
import { SseProvider } from './SseProvider';

type Props = {
    children: ReactNode;
    basename?: string;
    router?: FC<{ children: ReactElement }>;
};

export const SharedProvider: FC<Props> = ({
    children,
    basename,
    router: RouterElem = HashRouter,
}) => {
    const isGlobalSseEnabled = isFeatureEnabled((features) => features.globalSseNotifications);
    const { isActive } = useDarkMode();

    return (
        <StrictMode>
            <GDSProvider useDarkMode={isActive}>
                <RootErrorBoundary>
                    <QueryClientProvider withDevTools>
                        <RouterElem basename={basename}>
                            <>
                                {isGlobalSseEnabled && (
                                    <SseProvider eventBus={getSseEventBus()}>
                                        {children}
                                    </SseProvider>
                                )}
                                {!isGlobalSseEnabled && children}
                            </>
                        </RouterElem>
                    </QueryClientProvider>
                </RootErrorBoundary>
            </GDSProvider>
        </StrictMode>
    );
};
